/* eslint-disable */
<template>
  <section class="pedido-steps" v-if="!mostrar_edicion">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="section-title">
            <h4>Detalle</h4>
            <a @click="volverListado()" href="javascript:void(0)">
              <img class="d-none d-sm-block" :src="require('@/assets/img/backspace.svg')" alt="backspace">
            </a>
          </div>
        </div>
      </div>
      <div class="row mostrarPedido">
        <div class="col-md-12">
          <div class="confirmado">
            <div class="section-title p-0">
              <h5>Cuota ID
                <Tooltip :parent="'id'" :message="'Número de Cuota en el sistema.'">(?)</Tooltip>
                : {{ data.id }}
              </h5>
            </div>
            <div class="row m-auto">
              <div class="col-md-6">
                <div class="form-group" id="sku">
                  <label><strong>Sku
                    <Tooltip :parent="'sku'" :message="'Número de identificación interno Mccain.'">(?)</Tooltip>
                    :</strong> {{ this.country === 'Argentina' ? data.SKU : data.sku }}</label>
                </div>
              </div>
              <div class="col-md-6" v-if="this.country === 'Mexico'">
                <div class="form-group" id="channel">
                  <label><strong>Channel
                    <Tooltip :parent="'channel'" :message="'Canal de Venta en Mccain.'">(?)</Tooltip>
                    : </strong>{{ data.zone }}</label>
                </div>
              </div>
              <div class="col-md-6" v-if="this.country === 'Calatin'">
                <div class="form-group" id="client">
                  <label><strong>
                    Cliente
                    <Tooltip :parent="'client'" :message="'Cliente distribuidor de Mccain.'">(?)</Tooltip>
                    : </strong>{{ data.sold_to_name }}</label>
                </div>
              </div>
            </div>
            <div class="row m-auto" v-if="this.country === 'Argentina'">
              <div class="col-md-6">
                <div class="form-group" id="zone">
                  <label><strong>Region
                    <Tooltip :parent="'zone'" :message="'Número de identificación interno Mccain.'">(?)</Tooltip>
                    :</strong> {{ data.zone }}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group" id="vendedor">
                  <label><strong>Vendedor
                    <Tooltip :parent="'vendedor'" :message="'Canal de Venta en Mccain.'">(?)</Tooltip>
                    : </strong>{{ data.vendedor }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="this.country === 'Calatin'">
              <div class="form-group" id="plant">
                <label><strong>
                  Planta
                  <Tooltip :parent="'plant'" :message="'Número de planta de Mccain.'">(?)</Tooltip>
                  : </strong> {{ data.plant_id }}</label>
              </div>
            </div>
            <div class="row m-auto">
              <div class="col-md-6">
                <div class="form-group" id="quantity">
                  <label><strong>Cuota
                    <Tooltip :parent="'quantity'" :message="'La cuota de sku.'">(?)</Tooltip>
                    :</strong> {{ data.quantity }}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group" id="availability">
                  <label><strong>Disponible
                    <Tooltip :parent="'availability'" :message="'Disponible para compra.'">(?)</Tooltip>
                    : </strong>{{ data.availability }}</label>
                </div>
              </div>
            </div>
            <div class="row m-auto">
              <div class="col-md-6">
                <div class="form-group" id="start-date">
                  <label><strong>Fecha Inicio
                    <Tooltip :parent="'start_date'"
                             :message="'Este campo hace referencia a fecha de inicio de la cuota.'">(?)
                    </Tooltip>
                    : </strong>{{ data.start_date }}</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group" id="final-date">
                  <label><strong>Fecha Final
                    <Tooltip :parent="'final_date'" :message="'Este campo hace referencia a fecha final de la cuota.'">
                      (?)
                    </Tooltip>
                    : </strong>{{ data.final_date }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 next-btn d-none d-md-block">
                <a @click="confirmDelete" href="javascript:void(0)" class="btn-white">Eliminar</a>
                <a @click="editar" href="javascript:void(0)" class="btn-white">Editar</a>
                <a @click="volverListado" href="javascript:void(0)" class="btn-white">Volver al listado</a>
              </div>
              
               <!-- Botones para dispositivos pequeños -->
              <div class="col-12 next-btn d-block d-md-none mb-3">
                <a @click="confirmDelete" href="javascript:void(0)" class="btn-white" style="margin-right: auto; margin-left: auto;">Eliminar</a>
              </div>

              <div class="col-12 next-btn d-block d-md-none mb-3">
                <a @click="editar" href="javascript:void(0)" class="btn-white" style="margin-right: auto; margin-left: auto;">Editar</a>
              </div>

              <div class="col-12 next-btn d-block d-md-none mb-3">
                <a @click="volverListado" href="javascript:void(0)" class="btn-white" style="margin-right: auto; margin-left: auto;">Volver al listado</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <CuotaEdicion v-if="mostrar_edicion"
                :country="this.country"
                :selectedCuota="this.cuota"
                @ocultarEdicion="ocultarEdicion"
                @updateCuota="updateCuota"
  ></CuotaEdicion>
  <vue-basic-alert :duration="300" :closeIn="1000000" ref="alert"/>
</template>

<script>
import {route} from '@/enviroment';
import axios from 'axios';
import $ from 'jquery';
import Tooltip from '../../snippets/Tooltip.vue';
import CuotaEdicion from '../cuotas/CuotaEdicion.vue';

export default {
  name: "CuotaDetalle",
  props: {
    country: String,
    selectedCuota: Object
  },
  components: {
    Tooltip, CuotaEdicion,
  },
  data() {
    return {
      route: route,
      data: {},
      cuota: Object,
      mostrar_edicion: false,
    }
  },
  created() {
    this.initCuota();
  },
  methods: {
    initCuota() {
      this.cuota = this.selectedCuota;
      switch (this.country) {
        case 'Argentina':
          this.data = {
            id: this.cuota.ID,
            ID: this.cuota.ID,
            ean: this.cuota.ean,
            sku: this.cuota.SKU,
            SKU: this.cuota.SKU,
            cliente: this.cuota.cliente,
            zone: this.cuota.zona_nombre,
            zona_nombre: this.cuota.zona_nombre,
            vendedor: this.cuota.vendedor,
            quantity: this.cuota.Cajas,
            Cajas: this.cuota.Cajas,
            availability: this.cuota.disponible,
            disponible: this.cuota.disponible,
            Fecha_inicio: this.cuota.Fecha_inicio.substring(0, 10),
            Fecha_final: this.cuota.Fecha_final.substring(0, 10),
            start_date: this.cuota.Fecha_inicio.substring(0, 10),
            final_date: this.cuota.Fecha_final.substring(0, 10)
          };
          break;
        case 'Calatin':
          this.data = {
            id: this.cuota.id,
            sku: this.cuota.sku,
            sold_to: this.cuota.sold_to,
            sold_to_name: this.cuota.sold_to_name,
            plant_id: this.cuota.plant_id,
            quantity: this.cuota.quantity,
            availability: this.cuota.availability,
            start_date: this.cuota.start_date.substring(0, 10),
            final_date: this.cuota.final_date.substring(0, 10)
          };
          break;
        case 'Mexico':
          this.data = {
            id: this.selectedCuota.id,
            sku: this.selectedCuota.sap,
            sap: this.selectedCuota.sap,
            zone: this.selectedCuota.zone,
            quantity: this.selectedCuota.quantity,
            availability: this.selectedCuota.availability,
            start_date: this.selectedCuota.start_date.substring(0, 10),
            final_date: this.selectedCuota.final_date.substring(0, 10)
          };
          break;
        default:
          this.data = {};
          break;
      }
    },
    volverListado() {
      this.$emit("updateCuota", this.cuota);
      this.$emit("ocultarDetalle", false);
    },
    async confirmDelete() {
      const confirmed = await this.confirmDeleteDialog();
      if (!confirmed) return;
      axios.delete('/cuotificador/cuota/' + this.data.id)
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(() => {
            location.href = route + 'cuota-listado';
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.showAlert('warning', 'Atención!', msg);
          })
    },
    async confirmDeleteDialog() {
      return await this.$vbsModal.confirm({
        title: "Eliminar la cuota",
        message: "Está seguro que desea eliminar la cuota?",
        leftBtnText: 'No',
        rightBtnText: 'Si',
        displayCloseBtn: false
      });
    },
    editar() {
      this.mostrar_edicion = true;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    showAlert(type, title, message) {
        this.$refs.alert.showAlert(
            type,
            message,
            title,
            {
            iconSize: 35,
            iconType: 'solid',
            position: 'top right'
            }
        );

        setTimeout(() => {
            this.$refs.alert.$el.style.display = 'none';
        }, 5000);  // 5 segundos y se borra
    },
    mostrarCarga() {
      $('.loading').removeClass('d-none');
      $('.loading').addClass('d-block');
      $('#mostrarTablas').addClass('d-none');
    },
    ocultarCarga() {
      $('.loading').removeClass('d-block');
      $('.loading').addClass('d-none');
      $('#mostrarTablas').removeClass('d-none');
    },
    ocultarEdicion(variable) {
      this.mostrar_edicion = variable;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.ocultarCarga();
    },
    updateCuota(cuota) {
      switch (this.country) {
        case 'Argentina':
          this.data.quantity = cuota.Cajas;
          this.data.availability = cuota.disponible;
          this.data.Cajas = cuota.Cajas;
          this.data.disponible = cuota.disponible;
          this.data.Fecha_final = cuota.Fecha_final.substring(0, 10);
          this.data.final_date = cuota.Fecha_final.substring(0, 10);
          break;
        case 'Calatin':
        case 'Mexico':
          this.data.quantity = cuota.quantity;
          this.data.availability = cuota.availability;
          this.data.final_date = cuota.final_date.substring(0, 10);
          break;
        default:
          this.data = {};
          break;
      }
      this.cuota = this.data;
    }
  }

}
</script>